import config from "../config";
import { NamedPsrCaptureProfile } from "../Model/CaptureProfile";
import { sendGetRequest, sendPostRequest, sendDownloadTextRequest, sendPostRequestReturnValue, concatOptionalParameter, sendPutRequest } from "../Utility/FetchUtils";

class PsrCaptureProfileApi {
  static BASE_URL = config.SERVICE_URL + "/psr-capture-profiles";

  static exportPsrCaptureProfile(namedPsrCaptureProfile: NamedPsrCaptureProfile) {
    const url = this.BASE_URL + `/${namedPsrCaptureProfile.id}/:export`;
    return sendDownloadTextRequest(url, `${namedPsrCaptureProfile.captureProfileName}.xml`);
  }

  static importPsrCaptureProfile(psrCaptureProfileId: number, psrCaptureProfileText: string) {
    const url = this.BASE_URL + `/${psrCaptureProfileId}/:get-psr-capture-profile-from-xml`;
    return sendPostRequestReturnValue<NamedPsrCaptureProfile>(url, psrCaptureProfileText);
  }

  static getPsrCaptureProfiles(psrCaptureProfileName?: string){
    let url = this.BASE_URL + "/";

    url = concatOptionalParameter(url, {
      "capture-profile-name": psrCaptureProfileName
    });
    return sendGetRequest<NamedPsrCaptureProfile[]>(url);
  }

  static editPsrCaptureProfile(psrCaptureProfile: NamedPsrCaptureProfile){
    let url = this.BASE_URL + "/";

    return sendPutRequest(url, psrCaptureProfile);
  }
}

export default PsrCaptureProfileApi;
